<div class="min-h-full" style="background:#fafaf7">
  <div class="max-w-[800px] mx-auto px-5 sm:px-8 py-8 space-y-5">

    <!-- Back -->
    <button (click)="onCancel()" class="flex items-center gap-2 text-stone-400 hover:text-primary-600 transition-colors">
      <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/>
      </svg>
      <span class="text-[11px] font-bold uppercase tracking-wider">Retour aux formulaires</span>
    </button>

    @if (errorMessage()) {
      <div class="p-4 rounded-2xl bg-red-50 border border-red-100 text-sm text-red-700 flex items-center gap-3">
        <span class="material-icons text-base text-red-500">error_outline</span>
        {{ errorMessage() }}
      </div>
    }

    <div class="bg-white rounded-2xl border border-stone-100 shadow-sm overflow-hidden">

      <div class="px-6 py-4 border-b border-stone-100">
        <h1 class="text-base font-bold text-stone-800">Nouveau formulaire</h1>
      </div>

      <!-- Section 1: Info -->
      <div class="px-6 py-5 space-y-4">
        <p class="text-[10px] font-bold text-stone-400 uppercase tracking-widest">Informations</p>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div class="space-y-1.5">
            <label class="text-[11px] font-semibold text-stone-500">Nom (français) <span class="text-red-500">*</span></label>
            <input type="text" [value]="nomFr()" (input)="nomFr.set($any($event.target).value)"
              class="fiche-input w-full" placeholder="Ex: Licence joueur" autoDir />
          </div>
          <div class="space-y-1.5">
            <label class="text-[11px] font-semibold text-stone-500">Nom (arabe)</label>
            <input type="text" [value]="nomAr()" (input)="nomAr.set($any($event.target).value)"
              class="fiche-input w-full" placeholder="الاسم بالعربية" dir="rtl" />
          </div>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">

          <!-- Type -->
          <div class="space-y-1.5">
            <label class="text-[11px] font-semibold text-stone-500">Type <span class="text-red-500">*</span></label>
            <select [value]="type()" (change)="onTypeChange($any($event.target).value)" class="fiche-input w-full">
              <option value="">Sélectionner un type</option>
              @for (opt of typeOptions; track opt.value) {
                <option [value]="opt.value">{{ opt.label }}</option>
              }
            </select>
          </div>

          <!-- Code — auto-generated read-only -->
          <div class="space-y-1.5">
            <label class="text-[11px] font-semibold text-stone-500">Code</label>
            <div class="relative">
              <input type="text" [value]="code()" readonly
                class="fiche-input w-full font-mono bg-stone-50 text-stone-500 cursor-default select-none"
                placeholder="Généré automatiquement" />
              @if (isLoadingCode()) {
                <div class="absolute right-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 border-2 border-stone-300 border-t-primary-400 rounded-full animate-spin"></div>
              }
            </div>
          </div>

        </div>
      </div>

      <div class="border-t border-stone-100"></div>

      <!-- Section 2: Files -->
      <div class="px-6 py-5 space-y-3">
        <p class="text-[10px] font-bold text-stone-400 uppercase tracking-widest">Fichiers</p>

        <!-- PDF slot -->
        <div class="file-slot">
          <span class="file-slot-badge file-slot-pdf">PDF</span>
          <div class="flex-1 min-w-0">
            @if (pendingPdf()) {
              <span class="text-sm text-stone-700 truncate block">{{ pendingPdf()!.name }}</span>
            } @else {
              <span class="text-sm text-stone-400 italic">Aucun fichier</span>
            }
          </div>
          <div class="flex items-center gap-2 flex-shrink-0">
            @if (pendingPdf()) {
              <button type="button" (click)="clearFile('pdf')"
                class="file-slot-btn text-stone-400 hover:text-red-500">
                <span class="material-icons text-[16px]">clear</span>
              </button>
            }
            <label class="file-slot-btn text-stone-400 hover:text-primary-600 cursor-pointer" title="Choisir un PDF">
              <span class="material-icons text-[16px]">upload</span>
              <input type="file" accept=".pdf" class="hidden" (change)="onFileSelect('pdf', $event)" />
            </label>
          </div>
        </div>

        <!-- DOCX slot -->
        <div class="file-slot">
          <span class="file-slot-badge file-slot-docx">DOCX</span>
          <div class="flex-1 min-w-0">
            @if (pendingDocx()) {
              <span class="text-sm text-stone-700 truncate block">{{ pendingDocx()!.name }}</span>
            } @else {
              <span class="text-sm text-stone-400 italic">Aucun fichier</span>
            }
          </div>
          <div class="flex items-center gap-2 flex-shrink-0">
            @if (pendingDocx()) {
              <button type="button" (click)="clearFile('docx')"
                class="file-slot-btn text-stone-400 hover:text-red-500">
                <span class="material-icons text-[16px]">clear</span>
              </button>
            }
            <label class="file-slot-btn text-stone-400 hover:text-primary-600 cursor-pointer" title="Choisir un DOCX">
              <span class="material-icons text-[16px]">upload</span>
              <input type="file" accept=".docx" class="hidden" (change)="onFileSelect('docx', $event)" />
            </label>
          </div>
        </div>
      </div>

    </div>

    <!-- Buttons outside card -->
    <div class="flex justify-end gap-3">
      <button type="button" (click)="onCancel()"
        class="px-5 py-2.5 border border-stone-200 text-stone-600 rounded-xl hover:bg-stone-50 transition-colors text-sm font-medium">
        Annuler
      </button>
      <button type="button" (click)="onSave()" [disabled]="isLoading() || isLoadingCode()"
        class="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-600 text-white text-sm font-semibold rounded-xl hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-sm">
        @if (isLoading()) {
          <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
        } @else {
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
          </svg>
        }
        {{ isLoading() ? 'Création…' : 'Créer le formulaire' }}
      </button>
    </div>

  </div>
</div>
